<script>
import Chart from "./Chart.vue";

export default {
  name: "ResultContent",
  components: {
    Chart,
  },
  data: () => ({
    answerResult: [],
    categories: false,
    linkedIn: "",
    appRoot: "",
  }),
  computed: {
    result() {
      //calcula a nota com base nas respostas
      let result = 0;

      for (let i = 0; i < this.answerResult.values.length; i++) {
        result += parseInt(this.answerResult.values[i].peso);
      }

      result = result / this.answerResult.values.length;

      result = result / 10;

      result = result > 10 ? 10 : result;

      // Se for NaN zera
      if (isNaN(result)) {
        result = 0;
      }

      return result;
    },
    resultString() {
      // formatar a nota
      var result = this.result == 10 ? 10 : this.result.toFixed(2);

      return !isNaN(result) ? result : 0;
    },
    resultType() {
      var res = this.result;
      if (res <= 2.5) {
        return "BEGINNER";
      } else if (res >= 2.5 && res <= 5) {
        return "FOLLOWER";
      } else if (res > 5 && res <= 7.5) {
        return "ENGAGED";
      } else if (res > 7.5 && res <= 10) {
        return "LEADER";
      }
    },
  },
  methods: {
    //Categorias
    countCategories2() {
      // agrupa as awnser por categoria e conta quantas vezes cada categoria aparece
      let categories = [];
      let count = [];

      for (let i = 0; i < this.answerResult.values.length; i++) {
        let index = categories.indexOf(this.answerResult.values[i].category);
        if (index === -1) {
          categories.push(this.answerResult.values[i].category);
          count.push(1);
        } else {
          count[index]++;
        }
      }

      this.categories = {
        categories: categories,
        count: count,
      };
    },

    // Calcula a nota e agrupa soma de pesos por categoria
    countCategories() {
      let categories = [];
      let count = [];
      let peso = [];

      for (let i = 0; i < this.answerResult.values.length; i++) {
        let index = categories.indexOf(this.answerResult.values[i].category);
        if (index === -1) {
          categories.push(this.answerResult.values[i].category);
          count.push(1);
          peso.push(parseInt(this.answerResult.values[i].peso));
        } else {
          count[index]++;
          peso[index] += parseInt(this.answerResult.values[i].peso);
        }
      }

      let calc = {
        categories: categories,
        count: count,
        peso: peso,
      };

      var peso2 = [
        calc.peso[1] / calc.count[1] / 10,
        calc.peso[0] / calc.count[0] / 10,
        calc.peso[2] / calc.count[2] / 10,
        calc.peso[3] / calc.count[3] / 10,
      ];
      var titleCa = [
        calc.categories[1],
        calc.categories[0],
        calc.categories[2],
        calc.categories[3],
      ];

      this.categories = {
        categories: titleCa,
        count: peso2,
      };
    },
  },
  created() {
    this.appRoot = process.env.VUE_APP_ROOT;
    // Get param answerId
    var answerId = this.$route.params.answerId;

    // Carrega as respostas
    this.$store.dispatch("getAnswersResult", answerId).then((res) => {
      // Grava leas
      this.answerResult = this.$store.getters.answersResult;

      this.linkedIn = `https://www.linkedin.com/sharing/share-offsite/?url=${this.appRoot}`;

      // Conta as categorias para o grafico
      this.countCategories();
    });
  },
};
</script>
<template>
  <div id="ResultContent">
    <!-- Logo -->
    <div class="logo-meta">
      <img src="@/assets/img/logo-meta.png" alt="Logo" class="desk" />
      <img
        width="125"
        height="46"
        src="@/assets/img/logo_white.png"
        alt="Logo"
        class="mob"
      />
    </div>

    <div class="result-line desk">
      <img src="@/assets/img/result-line.png" />
    </div>

    <div class="result-a">
      <img src="@/assets/img/result-a.png" />
    </div>

    <div class="result-b">
      <img src="@/assets/img/result-b.png" />
    </div>

    <div class="result-text-a">
      <div class="sub-text-a">
        <h1>Thank you for participating in the survey</h1>
      </div>

      <div class="mob mob-line-separator"></div>

      <div class="sub-text-b">
        <div class="text">Your results:</div>
        <div class="result-values">
          <span class="result">{{ resultType }}</span>
        </div>
      </div>
    </div>

    <section class="result-test">
      <div class="wrapper">
        <div class="sidea">
          <div class="content" v-if="resultType == 'BEGINNER'">
            <div class="title">This shows us that…</div>
            <div class="result-text">
              Your company is starting to experiment with digital, but it has
              not yet embraced the solutions and technologies for transforming
              the company’s culture. It is worth identifying the desires that
              are holding you back, and the possible triggers for change.
              <br />
              <br />By responding to this survey, we understand that you are
              motivated to transform this scenario. We can help! The digital
              journey begins with the company’s cultural change. It is necessary
              to open space to trigger discussions and to seek help to know
              where and how to start. In addition to raising the leadership’s
              awareness for addressing the theme in all of the company’s areas,
              it is important to map your business and understand the best
              strategy for making the digital journey.
            </div>
            <div class="subcontent">
              <span class="destaque">
                <a href="https://www.meta.com.br/en/contact/" target="_blank"
                  >Click here</a
                >
              </span>
              and we will show you how we can build this path together.
            </div>
          </div>
          <div class="content" v-if="resultType == 'FOLLOWER'">
            <div class="title">This shows us that…</div>
            <div>
              Your company has initiated the digital journey and can evolve with
              agility and be at the forefront of the industry.
              <br />
              <br />By responding to this survey, we understand that you are
              motivated to help the company to accelerate. We can help! It is
              necessary to open space to trigger discussions on digital
              transformation and to seek help to know where to deepen knowledge
              about solutions and technologies that can be promising for your
              business, make a detailed mapping of your company and understand
              the best strategy for making the necessary change, so that your
              company goes beyond the “follower” level and becomes a model to be
              followed.
            </div>
            <div class="subcontent">
              <span class="destaque">
                <a href="https://www.meta.com.br/en/contact/" target="_blank"
                  >Click here</a
                >
              </span>
              and we will show you how we can build this path together.
            </div>
          </div>
          <div class="content" v-if="resultType == 'ENGAGED'">
            <div class="title">This shows us that…</div>
            <div>
              Your company appears to be engaged in the digital journey and on
              the path to being a role model for the market, with a focus on
              operational efficiency and enterprise-wide assets and
              accelerators.
              <br />
              <br />We can help by supporting the evolution of the journey
              across the company, involving the areas so that it becomes an
              agile and cognitive organization, with structuring and robust
              solutions in a flexible architecture for scale performance.
            </div>
            <div class="subcontent">
              <span class="destaque">
                <a href="https://www.meta.com.br/en/contact/" target="_blank"
                  >Click here</a
                >
              </span>
              and we will show you how we can build this path together.
            </div>
          </div>
          <div class="content" v-if="resultType == 'LEADER'">
            <div class="title">This shows us that…</div>
            <div>
              Your company is well-evolved in the digital journey, with a robust
              structure of solutions and performance at scale, and it is
              possible that it has already become an industry benchmark. The
              digital economy is growing rapidly and soon we will have new
              challenges with 5G, quantum computing and other exponential
              technologies coming to the market. We can help identify new
              opportunities for you to stay on top in your digital leadership.
            </div>
            <div class="subcontent">
              <span class="destaque">
                <a href="https://www.meta.com.br/en/contact/" target="_blank"
                  >Click here</a
                >
              </span>
              and we will show you how we can build this path together.
            </div>
          </div>
        </div>
        <div class="sideb">
          <chart
            :values="categories"
            :categories="JSON.stringify(categories)"
            v-if="categories"
          />

          <div class="controls">
            <div class="text">Access our Digital Transformation e-book</div>
            <div class="button">
              <a
                href="https://lp.meta.com.br/ebook-transformacao-digital"
                target="_blank"
              >
                <button class="button-28 hover-orange" role="button">
                  Download e-book
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="result-footer">
      <div class="content">
        <div class="text">
          Contribute to building the Digital Transformation Map.
          <br class="mob" />
          <span class="destaque">Refer the Survey to other professionals.</span>
        </div>
        <div class="mob linkedin-share-divider"></div>
        <div>
          <div class="share">SHARE:</div>
          <div class="social-icons">
            <!-- <a v-bind:href="this.linkedIn" class="social-icon" target="_blank">
              <img src="@/assets/img/social-icon-linkedin.png" alt="Linkedin" />
            </a> -->
            <a
              href="#"
              onclick="window.open('https://www.linkedin.com/sharing/share-offsite/?url=https://metait.ca/dxi/','', '_blank, width=500, height=500, resizable=yes, scrollbars=yes'); return false;"
            >
              <img src="@/assets/img/social-icon-linkedin.png" alt="Linkedin" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
